export const SET_INFO_PAGE = "[Info Help] Set the page";
export const CALL_ME = "[Info Help] On Call Me";
export const CALL_ME_SUCCESS = "[Info Help] On Call Me Success";
export const CALL_ME_ERROR = "[Info Help] On Call Me Error";

export const setInfoHelpPage = (
  statusMessage = "",
  helpText = "",
  callMe = false
) => {
  return {
    type: SET_INFO_PAGE,
    payload: { statusMessage, helpText, callMe }
  };
};


export const onCallMeClick = () => ({
  type: CALL_ME
});



// WEBPACK FOOTER //
// ./src/redux/actions/infoHelp.js